var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTouchApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 30.91V20.625C24.75 16.83 27.83 13.75 31.625 13.75C35.42 13.75 38.5 16.83 38.5 20.625V30.91C41.8275 28.6825 44 24.915 44 20.625C44 13.7775 38.4725 8.25 31.625 8.25C24.7775 8.25 19.25 13.7775 19.25 20.625C19.25 24.915 21.4225 28.6825 24.75 30.91ZM51.81 43.6425L39.325 37.4275C38.8575 37.235 38.3625 37.125 37.84 37.125H35.75V20.625C35.75 18.3425 33.9075 16.5 31.625 16.5C29.3425 16.5 27.5 18.3425 27.5 20.625V50.16C17.6 48.07 17.765 48.0975 17.4075 48.0975C16.555 48.0975 15.785 48.455 15.235 49.005L13.0625 51.205L26.6475 64.79C27.39 65.5325 28.435 66 29.5625 66H48.235C50.2975 66 51.8925 64.4875 52.195 62.48L54.2575 47.9875C54.285 47.795 54.3125 47.6025 54.3125 47.4375C54.3125 45.7325 53.2675 44.2475 51.81 43.6425Z",
    fill: "#4D7766"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTouchApp);
export default __webpack_public_path__ + "static/media/touch_app.de543840c465fb1162bd5876afd7df1c.svg";
export { ForwardRef as ReactComponent };